(() => {
  const boot = document.getElementById('PiccoDisplayCurrencyConfig');
  if (!boot || window.PiccoDisplayCurrency) return;
  const config = JSON.parse(boot.textContent);
  if (config.currency !== 'AUD') return;
  window.PiccoDisplayCurrency = { version: 1 };
  const supported = ['AUD', 'NZD', 'GBP'];
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch {} }
  };
  const countryCurrency = country => ({ NZ: 'NZD', GB: 'GBP' }[country] || 'AUD');
  const records = new WeakMap();
  const excluded = 'script,style,noscript,textarea,input,select,option,[contenteditable],iframe,afterpay-placement,.afterpay-placement,[id*="afterpay"],[class*="afterpay"],[id*="klarna"],[class*="klarna"],.shopify-payment-button,[data-picco-currency-ui],.sr-only,.visually-hidden';
  const rootSelector = '#MainContent,cart-drawer,#CartDrawer,.cart-drawer,quick-view,quick-add-modal';
  const money = /(?<![\w$£])(?:AUD\s*|A\s*)?\$\s*(\d[\d,]*(?:\.\d{1,2})?)(?:\s*AUD\b)?/g;
  let chosen = storage.get('picco_display_currency_v1');
  let currency = supported.includes(chosen) ? chosen : countryCurrency(config.country);
  let rates = null;
  let pending;
  let scheduled = false;
  let revision = 0;
  const selectors = new Set();
  const formatter = code => new Intl.NumberFormat(code === 'GBP' ? 'en-GB' : 'en-NZ', { style: 'currency', currency: code, currencyDisplay: 'code' });
  async function getRates() {
    if (rates) return rates;
    if (pending) return pending;
    pending = (async () => {
      let cached;
      try { cached = JSON.parse(storage.get('picco_display_rates_v1')); } catch {}
      if (cached?.expires > Date.now() && cached.NZD > 0 && cached.GBP > 0) return cached;
      const response = await fetch('https://open.er-api.com/v6/latest/AUD', { credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(6000) });
      if (!response.ok) throw new Error('Rates unavailable');
      const data = await response.json();
      if (data.result !== 'success' || data.base_code !== 'AUD' || !(data.rates?.NZD > 0) || !(data.rates?.GBP > 0) || Date.now() - data.time_last_update_unix * 1000 > 172800000) throw new Error('Invalid rates');
      const result = { NZD: data.rates.NZD, GBP: data.rates.GBP, expires: Math.min(Date.now() + 86400000, data.time_last_update_unix * 1000 + 172800000) };
      storage.set('picco_display_rates_v1', JSON.stringify(result));
      return result;
    })();
    try { rates = await pending; return rates; } finally { pending = null; }
  }
  function convertNode(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const current = node.nodeValue;
    let record = records.get(node);
    if (!record || current !== record.display) record = { original: current, display: current };
    const original = record.original;
    if (/\b(?:USD|NZD|CAD|HKD|SGD)\b|US\$|NZ\$|CA\$/.test(original)) return;
    money.lastIndex = 0;
    const display = currency === 'AUD' || !rates ? original : original.replace(money, (_, amount) => formatter(currency).format(Number(amount.replaceAll(',', '')) * rates[currency]));
    if (display !== current) node.nodeValue = display;
    record.display = display;
    records.set(node, record);
  }
  function makeUI(compact) {
    const wrapper = document.createElement('div');
    wrapper.dataset.piccoCurrencyUi = compact ? 'cart' : 'main';
    wrapper.className = 'picco-display-currency';
    const label = document.createElement('label');
    const title = document.createElement('span');
    title.textContent = config.labels.prices;
    const select = document.createElement('select');
    select.setAttribute('aria-label', config.labels.choose);
    supported.forEach(code => select.add(new Option(code, code)));
    select.value = currency;
    select.addEventListener('change', () => { chosen = select.value; storage.set('picco_display_currency_v1', chosen); apply(chosen); });
    label.append(title, select);
    const note = document.createElement('span');
    note.dataset.currencyNote = '';
    note.textContent = config.labels.note;
    wrapper.append(label, note);
    selectors.add(select);
    return wrapper;
  }
  function updateUI() {
    const main = document.querySelector('#MainContent');
    if (main && !document.querySelector('[data-picco-currency-ui="main"]')) { const footer = document.querySelector('footer-group,.footer-group'); const ui = makeUI(false); if (footer) footer.before(ui); else main.append(ui); }
    document.querySelectorAll('cart-drawer,#CartDrawer,.cart-drawer').forEach(drawer => {
      if (drawer.parentElement?.closest('cart-drawer,#CartDrawer,.cart-drawer')) return;
      const checkout = drawer.querySelector('[name="checkout"],a[href*="/checkout"],button[form="cart"]');
      if (checkout && !drawer.querySelector('[data-picco-currency-ui="cart"]')) checkout.before(makeUI(true));
    });
    selectors.forEach(select => { if (select.isConnected) select.value = currency; else selectors.delete(select); });
    document.querySelectorAll('[data-currency-note]').forEach(note => {
      const text = currency === 'AUD' ? config.labels.aud : config.labels.note;
      if (note.textContent !== text) note.textContent = text;
    });
  }
  function scan() {
    scheduled = false;
    observer.disconnect();
    try {
      document.querySelectorAll(rootSelector).forEach(root => {
        if (root.parentElement?.closest(rootSelector)) return;
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) convertNode(node);
      });
      updateUI();
      document.documentElement.dataset.piccoDisplayCurrency = currency;
    } finally { observer.observe(document.body, { subtree: true, childList: true, characterData: true }); }
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } }
  const observer = new MutationObserver(schedule);
  async function apply(next) {
    const request = ++revision;
    if (next !== 'AUD') {
      try { await getRates(); } catch { next = 'AUD'; }
    }
    if (request !== revision) return;
    currency = next;
    scan();
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('select[name="country_code"]')) return;
    const next = countryCurrency(event.target.value);
    storage.set('picco_display_currency_v1', next);
  }, true);
  async function start() {
    await apply(currency);
    if (!supported.includes(chosen) && !['NZ','GB'].includes(config.country)) {
      try {
        const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { signal: AbortSignal.timeout(4000) });
        const data = await response.json();
        const country = data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle;
        if (!chosen && ['NZ','GB'].includes(country)) await apply(countryCurrency(country));
      } catch {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
